import React from 'react';
import { Plus } from '@phosphor-icons/react';

import { trackCreateProject } from '../../../../analytics';

import { ButtonLink } from '../../../../components/general';

import { URL } from '../../../../constants';

const CreateProjectBtn = () => {
  return (
    <ButtonLink
      to={URL.PROJECT_SETTINGS}
      onClick={() => trackCreateProject('Home')}
      variant="custom"
      colour="custom"
      className="relative w-[calc(var(--project-block-width)_*_1.25)] xl:w-[var(--project-block-width)] aspect-video flex flex-col items-center justify-center p-2 gap-2 bg-white rounded-md"
    >
      <Plus className="w-8 h-8 sm:w-10 sm:h-10 fill-[url('#icon-purple-gradient')] transition-all group-hover:scale-[200%] group-hover:mt-8" />

      <div className="font-bold uppercase bg-gradient-purple-light bg-clip-text text-transparent transition-all group-hover:invisible group-hover:opacity-0">
        Create Project
      </div>
    </ButtonLink>
  );
};

export default CreateProjectBtn;
